/**
 * react-query options for the Routines page: her routines with their newest
 * runs, and the answers of one past run. Keyed under her NOVA routines, so
 * waking, pausing or changing a routine refreshes them with the check-in.
 *
 * Aliases: nova routines query, routines page query, routine run answers query
 */

import { queryOptions } from "@tanstack/react-query";

import {
  getMyNovaRoutineRunAnswers,
  listMyNovaRoutines,
} from "~/lib/functions/nova-routines";
import { novaHomeQueryKeys } from "~/lib/queries/novaHomeQueryKeys";

export const novaRoutinesQueryOptions = () =>
  queryOptions({
    queryKey: [...novaHomeQueryKeys.routines, "list"] as const,
    queryFn: () => listMyNovaRoutines(),
    staleTime: 30 * 1000,
  });

export const novaRoutineRunAnswersQueryOptions = (runId: string) =>
  queryOptions({
    queryKey: [...novaHomeQueryKeys.routines, "run", runId] as const,
    queryFn: () => getMyNovaRoutineRunAnswers({ data: { runId } }),
    // A past run's answers do not change; only its move's done state can.
    staleTime: 30 * 1000,
  });
